import { PrimaryButton } from '@ui-components/actions/special/DynamicWidthButtons'
import { Collapsible } from '@ui-components/containers/Collapsible'
import { MediumSectionContent } from '@ui-components/containers/MediumSectionContent'
import { Divider } from '@ui-components/decorative/Divider'
import { FlexColumnContainer } from '@ui-components/global/CommonStyling'
import { TertiaryHeading } from '@ui-components/typography/headings/TertiaryHeading'
import { PropsWithChildren } from 'react'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

export const CenteredPrimaryButton = styled(PrimaryButton)`
  align-self: center;
`

interface LoanDropdownProps {
  header: string
  isOpenByDefault?: boolean
  isLoadingButtonView?: boolean
  disabled?: boolean
  testId: string
}

export const LoanDropdown = ({
  children,
  header,
  isOpenByDefault,
  isLoadingButtonView,
  disabled,
  testId,
}: PropsWithChildren<LoanDropdownProps>) => {
  const { formatMessage } = useIntl()
  return (
    <Collapsible data-testid={testId} header={<TertiaryHeading header={header} />} open={isOpenByDefault}>
      <FlexColumnContainer>
        <MediumSectionContent>
          {children}
          <FlexColumnContainer>
            <Divider spacing={'small'} />
            <CenteredPrimaryButton
              label={formatMessage({ id: 'common-continue' })}
              type={'submit'}
              data-testid={`${testId}-continue-button`}
              loading={isLoadingButtonView}
              disabled={disabled}
            />
          </FlexColumnContainer>
        </MediumSectionContent>
      </FlexColumnContainer>
    </Collapsible>
  )
}
